import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  LOCALE_ID,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { routes } from './app.routes';
import { apiErrorInterceptor } from './shared/interceptors/api-error.interceptor';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { CustomIconRegistryService } from './shared/services/custom-icon-registry.service';
import { DeviceInfoService } from './shared/services/device-info.service';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideIonicAngular } from '@ionic/angular';
import { environment } from '../environments/environment';
import {
  installMaterialTouchedErrors,
  provideEwentsToast,
  provideGoogleMapsApiKey,
} from '@ewentscompany/ewents-components';

installMaterialTouchedErrors();

// Register Spanish locale
registerLocaleData(localeEs);

// Initialize device info service on app startup
function initializeApp(
  deviceInfoService: DeviceInfoService,
  customIconRegistryService: CustomIconRegistryService
) {
  return () => {
    deviceInfoService.initialize();
    customIconRegistryService.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    // Outer → enrich after Auth logout handling; never auto-toast.
    provideHttpClient(withInterceptors([apiErrorInterceptor, AuthInterceptor])),
    provideGoogleMapsApiKey(environment.googleMapsApiKey ?? ''),
    ...provideEwentsToast(),
    // Multi-line validation messages must grow the field, not overflow onto the next row.
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
    },
    { provide: LOCALE_ID, useValue: 'es' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [DeviceInfoService, CustomIconRegistryService],
      multi: true,
    },
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './i18n/',
        suffix: '.json',
      }),
      lang: 'en',
    }),
    provideIonicAngular({}),
  ],
};
